import { render, staticRenderFns } from "./risk-asset-group-relation-form.vue?vue&type=template&id=1b9236a6&"
import script from "./risk-asset-group-relation-form.vue?vue&type=script&lang=js&"
export * from "./risk-asset-group-relation-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports